import { A1_STATIC_URL } from '@shared/env';

export const getAudioUrl = (audioPath: string) => {
	return A1_STATIC_URL + `${audioPath.startsWith('/') ? audioPath : `/${audioPath}`}`;
};
